import { IProgramSummaryState, ITypeId } from './types';
import {
  GET_KEY_DATA_SUCCEEDED,
  GET_USF_TOTAL_SUCCEEDED,
  GET_RSF_TOTAL_SUCCEEDED,
  GET_WORKPLACE_BEHAVIOR_SUCCEEDED,
  GET_WORKSPACE_BREAKDOWN_SUCCEEDED,
  GET_SPACES_BREAKDOWN_SUCCEEDED,
  GET_SEATS_OCCUPIED_SUCCEEDED,
  SET_SUMMARY_SELECTED_ID_TYPE,
  SET_SELECTED_LEVELS,
  GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN_SUCCEEDED,
} from './actions';
import { DOWNLOAD_SUCCEEDED, START_LOCAL_DOWNLOAD } from '../downloads/actions';
import { CLEAN_UP_CURRENT_PROJECT } from '../projects/actions';

const EMPTY_ALT_WORKPOINT_DATA = { count: 0, seatsCount: 0 };

const initialState: IProgramSummaryState = {
  busy: false,
  downloadName: null,
  usfTotal: {
    circulation: null,
    total: null,
    subtotal: null,
    circulationPercentage: null,
  },
  rsfTotal: {
    totalRsf: null,
    buildingRsfLoadFactor: null,
  },
  workspaceBreakdown: { workstations: null, privateOffices: null },
  breakdown: {
    individualWorkspaces: [],
    meetingSpaces: [],
    amenitySpaces: [],
    supportSpaces: [],
  },
  alternativeWorkpointsBreakdown: {
    individualWorkspaces: EMPTY_ALT_WORKPOINT_DATA,
    meetingSpaces: EMPTY_ALT_WORKPOINT_DATA,
    amenitySpaces: EMPTY_ALT_WORKPOINT_DATA,
    supportSpaces: EMPTY_ALT_WORKPOINT_DATA,
    all: EMPTY_ALT_WORKPOINT_DATA,
  },
  keyData: {
    meetingSeats: null,
    workseatDensity: null,
    circulationPercentage: null,
    workseats: null,
    total: null,
    subtotal: null,
  },
  id: null,
  selectedType: '',
  selectedLevels: { floorIds: [], buildingIds: [] },
  workplaceBehavior: null,
  seatsOccupied: {
    individualWorkspaces: [],
    meetingSpaces: [],
    amenitySpaces: [],
    supportSpaces: [],
  },
};

const reducer = (state: IProgramSummaryState = initialState, action: any) => {
  switch (action.type) {
    case DOWNLOAD_SUCCEEDED:
      return {
        ...state,
        busy: false,
        downloadName: null,
      };
    case START_LOCAL_DOWNLOAD:
      return {
        ...state,
        busy: true,
      };
    case GET_USF_TOTAL_SUCCEEDED:
      return {
        ...state,
        usfTotal: action.payload,
      };
    case GET_RSF_TOTAL_SUCCEEDED:
      return {
        ...state,
        rsfTotal: action.payload,
      };
    case GET_WORKPLACE_BEHAVIOR_SUCCEEDED:
      return {
        ...state,
        workplaceBehavior: action.payload,
      };
    case GET_WORKSPACE_BREAKDOWN_SUCCEEDED:
      return {
        ...state,
        workspaceBreakdown: action.payload,
      };
    case GET_SPACES_BREAKDOWN_SUCCEEDED:
      return {
        ...state,
        breakdown: action.payload,
      };
    case GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN_SUCCEEDED:
      return {
        ...state,
        alternativeWorkpointsBreakdown: action.payload,
      };
    case GET_SEATS_OCCUPIED_SUCCEEDED:
      return {
        ...state,
        seatsOccupied: action.payload,
      };

    case GET_KEY_DATA_SUCCEEDED:
      return {
        ...state,
        keyData: action.payload,
      };

    case SET_SUMMARY_SELECTED_ID_TYPE: {
      const idSelectedType = action.payload as ITypeId;
      return {
        ...state,
        ...idSelectedType,
      };
    }

    case SET_SELECTED_LEVELS:
      return {
        ...state,
        selectedLevels: action.payload,
      };

    case CLEAN_UP_CURRENT_PROJECT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
